const mapId = "map-12";
const data = require('./data');
const colors = require('../../../colors');
const stateData = require('./state-data');
const colorNames = ['blue', 'teal', 'green', 'lime', 'yellow', 'orange', 'ochre', 'magenta', 'violet', 'purple']

const full = [];
colorNames.forEach(function(name) {
  full.push(colors.secondary[name][100].rgba)
})
const eighty = [];
colorNames.forEach(function(name) {
  eighty.push(colors.secondary[name][100].rgba)
});

let hues = [
  colors.secondary["orange"][100].rgba,
  colors.secondary["orange"][60].rgba,
  colors.secondary["yellow"][100].rgba,
  colors.secondary["yellow"][60].rgba,
  colors.secondary["blue"][40].rgba,
  colors.secondary["blue"][60].rgba,
  colors.secondary["blue"][100].rgba,
]

var countrySettings = [];
data.forEach(function(row) {
  var state = stateData.find(x => x.fips == row.stateCode);
  if (state) {
    var hue = hues[parseInt(row.LE) - 75];

    countrySettings.push({
      name: state.abbr,
      color: hue || "#888",
      border: "white",
      borderWidth: 1
    })
  }
})
var popoverEl;
$(document).ready(function() {
  $('#'+mapId).twism("create", {
    map: "custom",
    customMap: 'assets/maps/Blank_US_territories.svg',
    border: "white",
    territories: false,
    labels: true,
    backgroundColor: "white",
    color: "#888",
    hoverColor: false,
    hoverBorder: false,
    hover: function(state) {
      if (typeof popoverEl !== "undefined") popoverEl.popover('hide');
      if (state) {
        var content = "No data";
        var theState = stateData.find(x => x.abbr == state);
        if (theState) {
          var stateRow = data.find(x => x.stateCode == theState.fips);
          content = stateRow?'Life Expectancy: ' + stateRow.LE:'No data'
        }
        popoverEl = $('svg path#' + state)
        if (popoverEl && popoverEl.length) {
          if (!popoverEl.data('popover')) {
            popoverEl.data('toggle', 'popover');
            popoverEl.data('trigger', 'focus')
            popoverEl.data('placement', 'top');
            popoverEl.data('html', true);
            popoverEl.data('title', theState.name);
            popoverEl.data('content', content)
            popoverEl.data('container', 'body');
          }
          popoverEl.popover('show');
        }
        
      }
    },
    click: function() {
      return false;
    },
    individualCountrySettings: countrySettings
  });
});